angular.module('storefrontApp')
    .component('vcCustomerReviewsList', {
        templateUrl: 'themes/assets/js/common-components/vcCustomerReviewsList.tpl.html',
        bindings: {
            storeid: '@',
            productid: '@',
        },
        controller: ['$scope', 'vcCustomerReviewsService', function ($scope, customerReviewService) {
            const ctrl = this;

            $scope.customerReviews = [];
            $scope.isLastPage = false;
            $scope.loading = false;
            $scope.totalItems = 0;
            $scope.currentPage = 1;
            $scope.itemsPerPage = 3;

            $scope.$watch('currentPage', function () {
                getReviews($scope.currentPage).then(checkLastPage);
            });

            $scope.loadMore = function () {
                $scope.currentPage += 1;
            };

            function checkLastPage() {
                const totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);

                if (!$scope.totalItems || $scope.currentPage >= totalPages) {
                    $scope.isLastPage = true;
                }
            }

            function getReviews(page) {
                $scope.loading = true;

                return customerReviewService.search({
                    productIds: [ctrl.productid],
                    storeId: ctrl.storeid,
                    pageNumber: page,
                    pageSize: $scope.itemsPerPage,
                    sort: 'modifiedDate:desc',
                })
                    .then((response) => {
                        $scope.totalItems = response.data.totalCount;

                        response.data.results.forEach((newItem) => {
                            // we exclude duplication of customer reviews
                            if (!$scope.customerReviews.some((oldItem) => oldItem.id === newItem.id)) {
                                $scope.customerReviews.push(newItem);
                            }
                        });
                    })
                    .finally(() => {
                        $scope.loading = false;
                    });
            }
        }],
    });
